import { type FunctionComponent, lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterCuratePageProjectScenarioRules = lazy(() => {
  return new Promise<{ default: FunctionComponent }>((resolve, reject) => {
    import("curate/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.PageProjectScenarioRules />,
        });
      })
      .catch(reject);
  });
});

export const LazyCuratePageProjectScenarioRules = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterCuratePageProjectScenarioRules />
    </Suspense>
  );
};
